import { SiteShell } from "./SiteShell";

function Bar({ className = "" }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-lg bg-muted ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-foreground/10 to-transparent" />
    </div>
  );
}

export default function PageSkeleton({
  variant = "default",
}: {
  variant?: "default" | "contact" | "team";
}) {
  return (
    <SiteShell>
      <style>{`@keyframes shimmer { 100% { transform: translateX(100%); } }`}</style>
      <section className="mx-auto max-w-6xl px-6 pt-16 pb-12">
        <div className="mx-auto max-w-2xl space-y-4 text-center">
          <Bar className="mx-auto h-6 w-40 rounded-full" />
          <Bar className="mx-auto h-12 w-3/4" />
          <Bar className="mx-auto h-12 w-2/3" />
          <Bar className="mx-auto h-4 w-5/6" />
          <Bar className="mx-auto h-4 w-4/6" />
        </div>
      </section>

      {variant === "contact" ? (
        <section className="mx-auto grid max-w-6xl gap-6 px-6 pb-24 lg:grid-cols-3">
          <div className="space-y-4 lg:col-span-2 rounded-2xl border border-border bg-card p-6">
            <Bar className="h-5 w-40" />
            <div className="grid gap-4 sm:grid-cols-2">
              <Bar className="h-12" />
              <Bar className="h-12" />
            </div>
            <Bar className="h-12" />
            <Bar className="h-32" />
            <Bar className="h-12 w-32" />
          </div>
          <div className="space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-2xl border border-border bg-card p-5 space-y-3">
                <Bar className="h-10 w-10 rounded-xl" />
                <Bar className="h-4 w-24" />
                <Bar className="h-3 w-32" />
              </div>
            ))}
          </div>
        </section>
      ) : variant === "team" ? (
        <section className="mx-auto max-w-6xl px-6 pb-24">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-2xl border border-border bg-card p-5 space-y-3">
                <Bar className="h-24 w-24 rounded-full mx-auto" />
                <Bar className="h-4 w-2/3 mx-auto" />
                <Bar className="h-3 w-1/2 mx-auto" />
              </div>
            ))}
          </div>
        </section>
      ) : (
        <section className="mx-auto max-w-6xl px-6 pb-24">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="rounded-2xl border border-border bg-card p-6 space-y-4">
                <Bar className="h-12 w-12 rounded-xl" />
                <Bar className="h-5 w-1/2" />
                <Bar className="h-3 w-full" />
                <Bar className="h-3 w-5/6" />
                <Bar className="h-32" />
              </div>
            ))}
          </div>
        </section>
      )}
    </SiteShell>
  );
}
